import lazyScreen from '../utils/lazyScreen';
import { PNLPostingsRedirect, PNLReEntriesRedirect } from './pnlRedirects';
const PNLJournal = lazyScreen(() => import('../pages/pnl/PNLJournal/index.js'), 'pages/pnl/PNLJournal/index.js');
const PNLJournals = lazyScreen(() => import('../pages/pnl/PNLJournals/index.js'), 'pages/pnl/PNLJournals/index.js');
const PNLJournalGrouping = lazyScreen(() => import('../pages/pnl/PNLJournalGrouping/index.js'), 'pages/pnl/PNLJournalGrouping/index.js');
const PNLMonthlyReports = lazyScreen(() => import('../pages/pnl/PNLMonthlyReports/index.js'), 'pages/pnl/PNLMonthlyReports/index.js');
const PNLServeCostings = lazyScreen(() => import('../pages/pnl/PNLServeCostings/index.js'), 'pages/pnl/PNLServeCostings/index.js');
const PNLLedgerPostings = lazyScreen(() => import('../pages/pnl/PNLLedgerPostings/index.js'), 'pages/pnl/PNLLedgerPostings/index.js');
const PNLPostingRetry = lazyScreen(() => import('../pages/pnl/PNLPostingRetry/index.js'), 'pages/pnl/PNLPostingRetry/index.js');
const PNLPostingRetrys = lazyScreen(() => import('../pages/pnl/PNLPostingRetrys/index.js'), 'pages/pnl/PNLPostingRetrys/index.js');

export default [
    {
        path: '/pnl/PNLJournal/:code',
        component: PNLJournal
    },
    {
        path: '/pnl/PNLJournals',
        component: PNLJournals
    },
    {
        path: '/pnl/PNLJournalGrouping/:code',
        component: PNLJournalGrouping
    },
    {
        path: '/pnl/PNLMonthlyReports',
        component: PNLMonthlyReports
    },
    {
        path: '/pnl/PNLServeCostings',
        component: PNLServeCostings
    },
    {
        // Gộp vào /gl/GLJournals (đợt 5): chuyển hướng theo ?tab= cũ.
        path: '/pnl/PNLPostings',
        component: PNLPostingsRedirect
    },
    {
        path: '/pnl/PNLLedgerPostings',
        component: PNLLedgerPostings
    },
    {
        path: '/pnl/PNLReEntries',
        component: PNLReEntriesRedirect
    },
    {
        path: '/pnl/PNLPostingRetry/:code',
        component: PNLPostingRetry
    },
    {
        path: '/pnl/PNLPostingRetrys',
        component: PNLPostingRetrys
    }
];
